define('taoQtiItem/qtiXmlRenderer/renderers/Stylesheet',['tpl!taoQtiItem/qtiXmlRenderer/tpl/element'], function(tpl){
    return {
        qtiClass : 'stylesheet',
        template : tpl
    };
});
